module.exports = __webpack_public_path__ + "img/JMMSoloSpeech.bb303a2b.png";